import React from 'react';
import Box from '@material-ui/core/Box';

import Landing from './Landing';
import Players from './Players';
import SelectCategories from './SelectCategories';
import Game from './Game';
import AgeChecker, { isAgeVerified } from './AgeChecker';


export default function GameSetup() {
  const [age, setAge] = React.useState(isAgeVerified() ? 18 : 0);
	const [page, setPage] = React.useState("landing");
	const [players, setPlayers] = React.useState([]);
	const [categories, setCategories] = React.useState([]);

  const landingCallback = (direction) => {
    if (direction == "next"){
      setPage("players");
    }
  }

  const playerCallback = (direction, players) => {
    if (direction == "next"){
      setPlayers(players);
      setPage("categories");
    }
    if (direction == "previous"){
      setPage("landing");
    }
  }

  const categoryCallback = (direction, categories) => {
    if (direction == "next"){
      setCategories(categories);
      setPage("game");
    }
    if (direction == "previous"){
      setPage("players");
    }
  }

  if (!age) {
    return <AgeChecker setAge={setAge} />
  }

  return (
  	<Box>
      {page == "landing" ? <Landing callback={landingCallback} /> : null}
      {page == "players" ? <Players callback={playerCallback} /> : null}
      {page == "categories" ? <SelectCategories callback={categoryCallback} /> : null}
      {page == "game" ? <Game players={players} categories={categories} /> : null}
    </Box>
  )
}